import { render, staticRenderFns } from "./FillClaimTableUser.vue?vue&type=template&id=580bd6f6&scoped=true"
import script from "./FillClaimTableUser.vue?vue&type=script&lang=js"
export * from "./FillClaimTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580bd6f6",
  null
  
)

export default component.exports